<template>
  <generic-modal :title="$t('campaign')" :buttons="buttons" ref="generic_modal">
    <div class="tabs is-toggle is-fullwidth" ref="tabs">
      <ul>
        <li
          class="is-active"
          data-tab="general"
          @click="change_active_tab($event, this)"
        >
          <a>
            <i class="info icon" aria-hidden="true"></i>
            <span>{{ $t("general") }}</span>
          </a>
        </li>
        <li data-tab="images" @click="change_active_tab($event, this)">
          <a>
            <i class="file icon mb-0" aria-hidden="true"></i>
            <span>{{ $t("attachments") }}</span>
          </a>
        </li>
      </ul>
    </div>
    <div class="is-fluid" ref="contents">
      <div class="" data-tab="general">
        <form>
          <div class="columns">
            <div class="column">
              <div class="field">
                <label class="label">{{ $t("name") }}</label>
                <div class="control">
                  <input type="text" class="input" v-model="meta.name" />
                </div>
              </div>
            </div>
            <div class="column">
              <div class="field">
                <label class="label">{{ $t("send date") }}</label>
                <div class="control">
                  <input type="date" class="input" v-model="meta.send_date" />
                </div>
              </div>
            </div>
          </div>
          <div class="columns">
            <div class="column">
              <div class="field">
                <generic-dropdown
                  :title="$t('outbox template')"
                  :placeholder="$t('select one')"
                  :is_multiple="false"
                  url="/outbox/template/catalog"
                  name_field="name"
                  value_field="template_id"
                  @selected="template_changed"
                  ref="outbox_template_dropdown"
                >
                </generic-dropdown>
              </div>
            </div>
            <div class="column">
              <div class="field">
                <generic-dropdown
                  :title="$t('data source')"
                  :placeholder="$t('select one')"
                  :is_multiple="false"
                  url="/emarketing/datasource/catalog"
                  name_field="name"
                  value_field="datasource_id"
                  @selected="datasource_changed"
                  ref="datasource_dropdown"
                >
                </generic-dropdown>
              </div>
            </div>
          </div>
          <div class="">
            <div
              v-if="
                meta.settings &&
                meta.settings.arguments &&
                meta.settings.arguments.length
              "
            >
              <div class="title is-5">{{ $t("argument association") }}</div>
              <div class="field">
                <label class="label">{{ $t("email") }}</label>
                <div class="control">
                  <div class="select">
                    <select v-model="meta.settings.email_field">
                      <option
                        v-for="(field, fidx) in available_fields"
                        :key="fidx"
                        :value="field"
                      >
                        {{ field }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <div
                class="field"
                v-for="(argument, aidx) in meta.settings.arguments"
                :key="aidx"
              >
                <label class="label">{{
                  argument.name.replace("${", "").replace("}", "")
                }}</label>
                <div class="control">
                  <div class="select">
                    <select v-model="argument.associated_field">
                      <option
                        v-for="(field, fidx) in available_fields"
                        :key="fidx"
                        :value="field"
                      >
                        {{ field }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div class="is-hidden" data-tab="images">
        <div class="field">
          <div class="control">
            <generic-uploader
              ref="generic_uploader"
              :idle_label="$t('drop attachments here')"
              endpoint_url="/emarketing/campaign/attachment"
              :allow_multiple="true"
              @error="error_uploading"
              @success="success_uploading"
            />
          </div>
        </div>
        <div class="grid is-col-min-7">
          <div
            v-if="meta && meta.settings && meta.settings.images"
            class="cell"
            v-for="(photo, midx) in meta.settings.images"
            :key="midx"
          >
            <div class="card">
              <div class="card-image">
                <figure class="image is-128x128 m-auto py-3">
                  <v-lazy-image
                    :src="`${api_host}/drive/static/${photo.final_name}`"
                  />
                </figure>
              </div>
              <div class="card-content">
                <div class="media">
                  <div class="media-content">
                    <p class="subtitle is-7 has-text-centered"></p>
                  </div>
                </div>
              </div>
              <footer class="card-footer">
                <div
                  class="button is-secondary card-footer-item"
                  @click="meta.settings.images.splice(midx, 1)"
                  :data-tooltip="$t('delete')"
                >
                  <span class="icon">
                    <i class="fa fa-trash"></i>
                  </span>
                  <!-- <span>{{ $t("delete") }}</span> -->
                </div>
              </footer>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
  </generic-modal>
</template>
<script>
import {
  put,
  error_message,
  get,
  post,
  error_alert,
  success_message,
  api_host,
  generate_error_message_text,
  get_currency_settings,
  change_active_tab,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";
import GenericUploader from "@/components/generic_uploader/Index.vue";
import GenericDropdown from "@/components/generic_dropdown/Index.vue";
import VLazyImage from "v-lazy-image";
import moment from "moment";

export default {
  name: "CampaignModal",
  components: {
    GenericModal,
    GenericUploader,
    VLazyImage,
    GenericDropdown,
  },
  props: {},
  data() {
    return {
      available_fields: [],
      selected_outbox_template: {},
      selected_datasource: {},
      api_host,
      buttons: [
        {
          text: this.$t("save"),
          class: "is-primary is-rounded",
          icon: "fa fa-save",
          click: this.save,
          disabled: "this.is_form_invalid",
        },
        // {
        //   text: this.$t("fecth data"),
        //   class: "is-primary is-rounded",
        //   icon: "fa fa-bolt",
        //   click: this.fetch_data,
        // },
        {
          text: this.$t("cancel"),
          class: "is-rounded",
          icon: "fa fa-close",
          click: this.close_modal,
        },
      ],
      meta: { settings: {} },
      error: "",
      // uuid: "",
    };
  },
  computed: {
    is_form_invalid() {
      let v = this;
      // return false;
      return !v.meta.name || !v.meta.send_date || !v.meta.outbox_template_id;
    },
  },
  methods: {
    change_active_tab,
    get_currency_settings,
    close_modal() {
      let v = this;
      v.$refs.generic_modal.close_modal();
      v.set_initial_state();
    },
    show_modal() {
      let v = this;
      v.set_initial_state();
      v.$refs.generic_modal.show_modal();
    },
    edit_modal(campaign_uuid) {
      let v = this;
      v.set_initial_state();
      v.campaign_uuid = campaign_uuid;
      get("/emarketing/campaign", { uuid: campaign_uuid })
        .then((response) => {
          v.meta = response;
          if (response.send_date)
            v.meta.send_date = moment(response.send_date).format("YYYY-MM-DD");

          if (response.outbox_template_id)
            v.$refs.outbox_template_dropdown.set_value(
              response.outbox_template_id
            );

          if (response.datasource_id)
            v.$refs.datasource_dropdown.set_value(response.datasource_id);
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        })
        .finally(() => {
          v.$refs.generic_modal.show_modal();
        });
    },
    save() {
      let v = this;
      let data = { ...v.meta };
      console.log("v.campaign_uuid", v.campaign_uuid);
      if (!v.campaign_uuid) {
        put("/emarketing/campaign", data)
          .then(() => {
            v.$emit("success");
            v.close_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
      } else {
        post("/emarketing/campaign", data)
          .then(() => {
            v.$emit("success");
            v.close_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
      }
    },
    set_initial_state() {
      let v = this;
      v.meta = {
        settings: {
          arguments: [],
        },
      };
      v.campaign_uuid = "";
      v.available_fields = [];
      v.selected_outbox_template = {};
      v.selected_datasource = {};
      v.error = "";
      v.$refs.generic_uploader.clear();
      v.$refs.outbox_template_dropdown.clear();
      v.$refs.datasource_dropdown.clear();
      // v.uuid = "";
    },
    error_uploading(error) {
      let v = this;
      v.error = generate_error_message_text(error);
    },
    success_uploading(response) {
      let v = this;
      // v.$refs.generic_uploader.clear();
      let rspnse = JSON.parse(response.serverId);
      let data = {
        file_id: rspnse.file.file_id,
        final_name: rspnse.final_name,
        meta: rspnse.file.settings,
        original_name: rspnse.file.name,
      };
      if (v.meta.settings.images) {
        v.meta.settings.images.push(data);
      } else {
        v.meta.settings.images = [data];
      }
    },
    template_changed(value) {
      // console.log("template_changed", value);
      let v = this;
      if (value) {
        v.meta.outbox_template_id = value.template_id;
        v.meta.settings.arguments = value.settings
          ? value.settings.arguments
            ? value.settings.arguments.map((arg) => {
                let associated_value = "";
                if (v.meta.settings.arguments) {
                  let found = v.meta.settings.arguments.find(
                    (a) => a.name === arg.name
                  );
                  if (found) associated_value = found.associated_field;
                }
                return {
                  name: arg.name,
                  associated_field: associated_value,
                };
              })
            : []
          : [];
      }
    },
    datasource_changed(value) {
      let v = this;
      if (value) {
        v.selected_datasource = value;
        v.meta.datasource_id = value.datasource_id;
        v.available_fields = value.settings ? value.settings.fields : [];
      }
    },
    fetch_data() {
      let v = this;
      if (!v.meta.datasource_id) {
        error_alert(v.$t("select data source"));
        return;
      }
      get("/emarketing/datasource/fetch", { uuid: v.selected_datasource.uuid })
        .then((response) => {
          success_message(response);
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        });
    },
  },
  mounted() {},
  watch: {
    is_form_invalid() {
      let v = this;
      v.buttons[0].disabled = v.is_form_invalid;
    },
  },
};
</script>
<style></style>
